import React from 'react';
import { oneOfType, number, string } from 'prop-types';
import _reduce from 'lodash/reduce';
import _groupBy from 'lodash/groupBy';
import { useDesignStore } from '../../../store/design/context';

const getQuantity = (products, groupByKey, groupKey) => {
  const groupedProducts = _groupBy(products, groupByKey);
  return _reduce(groupedProducts?.[groupKey], (prev, curr) => {
    let count = prev || 0;
    if (curr?.choiceBundle) {
      return count;
    }
    if (curr?.Quantity) {
      count += curr.Quantity;
      return count;
    }
    count += 1;
    return count;
  }, 0);
};

const ChoiceQuantity = ({ choiceId }) => {
  const products = useDesignStore((state) => state.design.products);
  const quantity = getQuantity(products, 'choiceId', choiceId);

  if (!quantity) {
    return null;
  }

  return (
    <div
      className="custom-tile-quantity"
      style={{ textIndent: String(quantity).length === 1 ? '2.5rem' : '2rem' }}
    >
      {quantity}
    </div>
  );
};

ChoiceQuantity.propTypes = {
  choiceId: oneOfType([number, string]).isRequired
};

export default ChoiceQuantity;
